<template>
  <v-row>
    <v-col cols="12">
      <Form
        dispatch="projectMeteringStore/sourceAdapterStore/create"
        button_title="create"
        button_icon="mdi-plus"
        :sourceAdapter="sourceAdapter"
      ></Form>
    </v-col>
  </v-row>
</template>

<script>
import Form from "./FormSourceAdapter.vue";
export default {
  name: "NewSourceAdapter",
  components: {
    Form
  },
  computed: {
    sourceAdapter: {
      get() {
        return {
          authentication: "-",
          type: ""
        };
      }
    }
  }
};
</script>

<style scoped></style>
